module.exports = __webpack_public_path__ + "cristmas.f1d4afb287ce1aef8e68.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.eot
// module chunks = styles